import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Alert from '@components/common/Alert';
import Loader from '@components/common/Loader';
import { getIdpByName } from './helpers';

function SsoLogin() {
  const { shuttleRootPath: idpName } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const idp = getIdpByName(idpName);
    if (!idp) {
      return setError(`Error: no configuration found for ${idpName}`);
    }

    // eslint-disable-next-line consistent-return
    (async () => {
      try {
        const initResult = await idp.init(idpName);
        if (initResult) {
          const loginResult = await idp.tryLoginWithIdpCode();
          window.location.replace(`${window.location.origin}${loginResult.redirectToPath}`);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        if (e.response?.data?.details === 'QUOTE_EXPIRED') {
          setError(`The quote has already expired, please return to ${idpName}`);
        } else if (e.response?.data?.details === 'MISSING_PHONE_NUMBER') {
          // TODO: this copy names NetBenefits, so it only reads correctly for Fidelity GID — the only
          // income solution that uses a phone number during SSO today (the gate lives in the GID idp
          // implementation, services/lambda_api/lib/sso/idps/fidelity.js). When a second solution adopts
          // SMS ID verification, this needs per-income-solution copy with a solution-neutral fallback.
          setError(`We couldn't find a phone number on file for you, which is required to verify your identity when signing. Please return to NetBenefits to add or update your phone number, then try again.`);
        } else {
          setError(`There was an error during the login process, please try again later`);
        }
      }
    })();

    return () => idp?.cancelCurrentRequest();
  }, [idpName]);

  if (error) {
    return (
      <Alert
        variant="danger"
        message={error}
      />
    );
  }

  // TODO - update messaging based on IDP and which shuttle this should be going to
  return (
    <Loader message="You are being automatically redirected to your experience..." />
  );
}

export default SsoLogin;
